/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_UpdateInputs */

const en_recipe_shopping_update = /** @type {(inputs: Recipe_Shopping_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save portions`)
};

const de_recipe_shopping_update = /** @type {(inputs: Recipe_Shopping_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portionen speichern`)
};

/**
* | output |
* | --- |
* | "Save portions" |
*
* @param {Recipe_Shopping_UpdateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_update = /** @type {((inputs?: Recipe_Shopping_UpdateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_UpdateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_update(inputs)
	return en_recipe_shopping_update(inputs)
});